import { cn } from '@/lib/utils';

/**
 * The mark: the Run Ledger rail itself — a hairline with notches and a terminal
 * stop. The same device the product is built on, at 20px.
 *
 * The expert variant carries a second, hatched track beside the first. That is
 * the whole difference between this dashboard and the client's: one thread,
 * two visibilities.
 */
export function Mark({ className }: { className?: string }) {
  return (
    <svg aria-hidden viewBox="0 0 20 20" className={cn('h-5 w-5', className)}>
      <path d="M5 2v16" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" opacity="0.5" />
      <path d="M5 5h6M5 9h8M5 13h5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
      <path
        d="M2 3v3M2 8v3M2 13v3"
        stroke="var(--c-hidden)"
        strokeWidth="1.3"
        strokeLinecap="round"
        opacity="0.85"
      />
      <circle cx="5" cy="17" r="2" fill="var(--c-action)" />
    </svg>
  );
}
